import { IActivityAction, IBaseAction } from '@models/actions/IBaseAction';
import { ModalSize } from '@/types/ModalSize';
import { ActivityActionsService } from '@services/actions/ActivityActionsService';
import { sendModalMsg } from '@molecules/ModalMessages';
import React from 'react';
import { BaseActionExecutor } from './IActionExecutor';
import { getActivityIdFromCompositeId } from '@utils/helpers';
import { IModalMessage } from '@molecules/ModalMessages/IModalMessage';

export abstract class ActivityBaseActionExecutor extends BaseActionExecutor {
    protected _errors?: string[];
    protected _objId?: string;
    protected _activityId?: string;
    protected _parentId?: string;
    protected _action?: IActivityAction;
    protected _rowData?: any;
    protected _completeHandler?: (isSucceed: boolean) => void;

    run = async (
        objId: string,
        parentId: string | undefined,
        action: IBaseAction,
        rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
        raiseVisualElement?: () => void,
        modalSize?: ModalSize | null,
    ) => {
        this._objId = objId;
        this._activityId = getActivityIdFromCompositeId(objId);
        this._parentId = parentId;
        this._action = action as IActivityAction;
        this._rowData = rowData;
        this._completeHandler = completeHandler;

        let isMultipleObjects = objId.split(',').filter((item) => item).length > 1;
        let serv = new ActivityActionsService();

        const runAction = async () => {
            if (isMultipleObjects && action.hasGroupAccessibility) {
                // проверка accessibility для группы активити
                await serv
                    .checkActionGroupAccessibility(objId, action.key)
                    .then((res) => {
                        if (res.data.isAccessibly) {
                            //успешная проверка групповой Accessibility
                            if (this.runInternal)
                                this.runInternal(objId, parentId, action, rowData, completeHandler, modalSize);
                            if (raiseVisualElement) raiseVisualElement();
                        } else {
                            this._errors = res.data.errors;
                            if (raiseVisualElement) raiseVisualElement();
                        }
                    })
                    .catch(() => {
                        if (completeHandler) completeHandler(false);
                    });
            } else {
                if (this.runInternal) this.runInternal(objId, parentId, action, rowData, completeHandler, modalSize);
                if (raiseVisualElement) raiseVisualElement();
            }
        };

        if (action.hasAccessibility) {
            await serv
                .checkActionAccessibility(this._activityId, action.key)
                .then(async (res) => {
                    if (res.data.isAccessibly) {
                        //успешная проверка Accessibility
                        await runAction();
                    } else {
                        this._errors = res.data.errors;
                        if (raiseVisualElement) raiseVisualElement();
                    }
                })
                .catch(() => {
                    if (completeHandler) completeHandler(false);
                });
        } else {
            await runAction();
        }
    };

    abstract runInternal: (
        objId: string,
        parentId: string | undefined,
        action: IBaseAction,
        rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
        modalSize?: ModalSize | null,
    ) => void;

    visualElement = () => {
        if ((this._errors?.length ?? 0) > 0) {
            sendModalMsg({
                message: this._errors,
                type: 'error',
                closeBtnClick: () => {
                    if (this._completeHandler) this._completeHandler(false);
                },
            } as IModalMessage);
            return <></>;
        } else {
            return this.visualElementInner ? this.visualElementInner() : <></>;
        }
    };

    visualElementInner?: () => React.ReactElement;
}
